import React from 'react';
import { Spinner } from '../../../../components/ui/Spinner';

interface LoadingOverlayProps {
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message }) => (
  <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
    <div className="bg-card p-8 rounded-xl flex flex-col items-center shadow-lg">
      <Spinner size="lg" />
      {message && <p className="text-sm text-foreground mt-4">{message}</p>}
    </div>
  </div>
);

export default LoadingOverlay;
